/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Thunder Icon component.
 */
export const ThunderIcon = ({size = IconSize.small, color = dlsColor('grey3')}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({size, color});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M12.8468 7.35554L6.00463 13.855C5.90463 13.95 5.77305 14 5.63094 14C5.53094 14 5.43621 13.975 5.352 13.925C5.14673 13.8 5.05199 13.56 5.13094 13.3401L6.47832 9.50036H3.52567C3.32041 9.50036 3.13093 9.38537 3.04672 9.21039C2.96251 9.0304 2.99409 8.82542 3.12567 8.67543L8.91517 2.17595C9.07306 2.00097 9.33096 1.95097 9.54675 2.05096C9.7678 2.15095 9.88359 2.38594 9.83096 2.61092L8.92043 6.5006H12.4731C12.6836 6.5006 12.8783 6.62559 12.9573 6.81058C13.0415 6.99556 12.9994 7.21055 12.8468 7.35554Z' fill={iconColor} />
    </svg>
  );
};
